export default function AboutPage() {
  return (
    <>
      <div className="pg-hdr">
        <h1>About the Papua LNG Project</h1>
        <p>How the project is structured, who's building it, and why this portal exists.</p>
      </div>

      <section className="sec">
        <div className="container">
          <div className="sec-hdr">
            <div className="eyebrow">Project Structure</div>
            <h2>Operator, EPC contractors &amp; the Korean logistics chain</h2>
          </div>

          <div className="chain">
            <div className="chain-step">
              <div className="cs-role">Operator</div>
              <div className="cs-name">ExxonMobil</div>
              <div className="cs-desc">Operator of the Papua LNG Project, alongside co-venturers TotalEnergies, Santos, ENEOS Xplora, Kumul Petroleum and MRDC, developing the Elk-Antelope gas fields and associated infrastructure in the Gulf and Central Provinces of Papua New Guinea.</div>
            </div>
            <div className="chain-arrow">↓</div>
            <div className="chain-step">
              <div className="cs-role">Upstream EPC Contractor</div>
              <div className="cs-name">Daewoo Engineering &amp; Construction (Daewoo E&amp;C)</div>
              <div className="cs-desc">Leads the upstream package — the Central Processing Facility (CPF) and well pads — following FEED work carried out with Tripatra. This is the upstream construction contract this portal is oriented around.</div>
            </div>
            <div className="chain-arrow">↓</div>
            <div className="chain-step">
              <div className="cs-role">Downstream EPC Contractor</div>
              <div className="cs-name">JGC Corporation + Hyundai Engineering &amp; Construction</div>
              <div className="cs-desc">A Japan–Korea joint venture selected for the downstream onshore liquefaction (LNG plant) package.</div>
            </div>
            <div className="chain-arrow">↓</div>
            <div className="chain-step">
              <div className="cs-role">Korean Logistics Chain</div>
              <div className="cs-name">Project Carrier Korea (marine, heavy-lift &amp; project logistics)</div>
              <div className="cs-desc">Korean heavy-lift, marine transport and crane specialists supporting the upstream construction logistics — deck carriers, landing craft, barges, tugs, SPMT and heavy cranes moving modules and equipment into PNG.</div>
            </div>
          </div>

          <p style={{ maxWidth: 720, margin: "2.5rem auto 0", color: "var(--gr)", fontSize: ".92rem", lineHeight: 1.8, textAlign: "center" }}>
            Beneath these Tier 1 contractors sits a wide subcontracting chain — construction,
            fabrication, marine and river logistics, camp and catering services, engineering
            support and equipment supply — much of it open to qualified Korean companies
            and workers. See <strong>Business Opportunities</strong> for how that chain works.
          </p>
        </div>
      </section>

      <section className="sec sec-alt">
        <div className="container">
          <div className="sec-hdr">
            <div className="eyebrow">About This Portal</div>
            <h2>A joint Korean &amp; Papua LNG landowner initiative</h2>
          </div>
          <div className="grid2">
            <div className="info-card">
              <h3>🇰🇷 Why Korea Papua LNG exists</h3>
              <p>
                With Daewoo E&amp;C's award of the upstream EPC package, a large and
                sustained wave of Korean contractors, engineers, tradespeople and
                specialist companies will need to mobilise to Papua New Guinea.
                This portal exists to make that process easier — clear information
                on labour law and visas, a simple way to register interest as a
                worker or a company, and a direct line into the project's Korean
                logistics and subcontracting chain.
              </p>
            </div>
            <div className="info-card">
              <h3>🇵🇬 A partnership with Papua LNG landowners</h3>
              <p>
                The portal is established by a group of Koreans working on the
                project together with Papua LNG landowners, so that the Korean
                workforce and supply chain mobilising into the project area connects
                properly with local communities, local content requirements and
                local business opportunities from the outset.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
